import { createFileRoute } from "@tanstack/react-router";

// Thẻ đang mở nằm trên URL (cùng khuôn /branch-kpi): trang chi tiết một mã
// quay về đúng thẻ, và đường dẫn dán qua chat mở đúng chỗ.
type PromosSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/promos/")({
  validateSearch: (search: Record<string, unknown>): PromosSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
